import type { TypeSelectOption } from '@thefarmersfront/kitchen';

/**
 * 입고대행서비스 이용 시, 입고센터 온도대에 따라 경유센터(CC03)의 온도대 옵션을 찾는 함수
 *
 * - CC02/CC04에서 선택한 온도대의 뒷자리 2개와 매칭되는 CC03 온도대를 찾거나
 * - 복사 시 API가 반환한 정확한 CC03 온도대 옵션을 찾습니다.
 *
 * @param cc03TemperatureOptions 경유센터(CC03)의 온도대 옵션 배열
 * @param targetTemperatureCode 찾을 온도대 코드 (예: 'KCH1' 또는 'GPH1')
 * @param matchBySuffix true면 뒷자리 2개로 매칭, false면 정확한 값으로 매칭 (기본값: true)
 * @returns 매칭되는 CC03 온도대 옵션 또는 null
 *
 * @example
 * // 온도대 또는 입고대행서비스 이용 여부 선택 시: 뒷자리 2개로 매칭
 * getMatchingXDockCenter(cc03Options, 'KCH1')
 * // => CC03에서 'H1'로 끝나는 옵션 반환 (예: 'GPH1')
 *
 * @example
 * // 입고 복사 시: 정확한 값으로 매칭
 * getMatchingXDockCenter(cc03Options, 'GPH1', false)
 * // => 'GPH1'과 정확히 일치하는 옵션 반환
 */
export const getMatchingXDockCenter = (
  cc03TemperatureOptions: TypeSelectOption<string>[],
  targetTemperatureCode: string | null,
  matchBySuffix = true
): TypeSelectOption<string> | null => {
  if (!targetTemperatureCode) return null;

  if (matchBySuffix) {
    const targetSuffix = targetTemperatureCode.slice(-2);
    return cc03TemperatureOptions.find(({ value }) => value.slice(-2) === targetSuffix) ?? null;
  }

  return cc03TemperatureOptions.find(({ value }) => value === targetTemperatureCode) ?? null;
};
